module.exports = __webpack_public_path__ + "static/media/20201114_145527_000_IMG_9918.e224c09a.jpg";